import { DeprecatedErrorIcon, LoadingSignIcon, Popover, useTheme } from '@lokalise/louis';

import { PopoverText } from '../../StyleGuideRow/style';
import { IconContainer, SyncButtonContainer, SyncButtonContent, TextContainer } from '../styles';

type GeneralErrorStateButtonProps = {
    onClick: () => void;
    loading?: boolean;
};

export const GeneralErrorStateButton = ({ loading, onClick }: GeneralErrorStateButtonProps) => {
    const theme = useTheme();

    return (
        <Popover
            content={<PopoverText>Something went wrong. Click to sync again or contact support.</PopoverText>}
            triggerEvent="hover"
            withArrow
        >
            <SyncButtonContainer onClick={onClick} $hasError disabled={loading} aria-label="Click to sync again">
                <SyncButtonContent align="center">
                    <IconContainer align="center" justify="center">
                        {loading ? (
                            <LoadingSignIcon size="16px" ariaLabel="LoadingIcon" />
                        ) : (
                            <DeprecatedErrorIcon
                                color={theme.color.background.action.danger.default}
                                size="16px"
                                ariaLabel="ErrorIcon"
                            />
                        )}
                    </IconContainer>
                    <TextContainer>Click to sync again</TextContainer>
                </SyncButtonContent>
            </SyncButtonContainer>
        </Popover>
    );
};

export default GeneralErrorStateButton;
